import { Reducer } from "redux";

import {
  PartnerReferralAction,
  PartnerReferralClearErrorActionType,
  PartnerReferralGetFailActionType,
  PartnerReferralGetSuccessActionType,
} from "./partner-referral.actions";

export const partnerReferralReducer: Reducer<
  PartnerReferralState,
  PartnerReferralAction
> = (state = {}, action) => {
  switch (action.type) {
    case PartnerReferralGetSuccessActionType:
      return {
        ...state,
        partnerUrl: action.partnerReferral.partnerUrl,
        error: action.partnerReferral.errorMessage,
      };
    case PartnerReferralGetFailActionType:
      return {
        ...state,
        partnerUrl: null,
        error: action.errorMessage,
      };
    case PartnerReferralClearErrorActionType:
      return { ...state, error: null, partnerUrl: null };
    default:
      return state;
  }
};

export interface PartnerReferralState {
  partnerUrl?: string | null;
  error?: string | null;
}
